exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.user-create\r\n{\r\n    padding: -15px;\r\n}\r\ndiv.user-create label\r\n{\r\n    font-weight: bold;\r\n}\r\n.loginfailed{\r\n    background-color: #f5d0cd;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-infomation/account-infomation.component.css
// module id = ../../../../../src/app/account-infomation/account-infomation.component.css
// module chunks = main